import { DEFAULT_USER_INFO } from "@features/mySph/utils/constants";
import { SanitizedUserInfoObject } from "@features/mySph/utils/types";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface UserStore {
  userInfo: SanitizedUserInfoObject;
  isAuthenticated: boolean;
  setUserInfo: (userInfo: SanitizedUserInfoObject) => void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
}

const useUserInfoStore = create(
  persist<UserStore>(
    (set) => ({
      userInfo: DEFAULT_USER_INFO,
      isAuthenticated: false,
      setUserInfo: (userInfo: SanitizedUserInfoObject) => {
        set({ userInfo });
      },
      setIsAuthenticated: (isAuthenticated: boolean) => {
        set({ isAuthenticated });
      },
    }),
    {
      name: "bt-user", // unique name
      storage: createJSONStorage(() => localStorage), // Specify localStorage as the storage option
    }
  )
);

export default useUserInfoStore;
